import FilterForm from '../../../components/forms/FilterForm';
import { DeleteButton, EditButton, TextField, useTable } from '@refinedev/antd';
import { Form, Input, Space, Table } from 'antd';
import { GroupsColumn } from './components/groups-column';
import { HttpError } from '@refinedev/core';
import { IAgent } from 'interfaces/agents';
import { ListLayout } from 'components/layout/layout/ListLayout';

export const AgentList = () => {
  const { tableProps, searchFormProps } = useTable<
    IAgent,
    HttpError,
    { byName: string; byLogin: string }
  >({
    onSearch: ({ byName, byLogin }) => [
      {
        field: 'filter[by_name]',
        operator: 'eq',
        value: byName
      },
      {
        field: 'filter[by_login]',
        operator: 'eq',
        value: byLogin
      }
    ]
  });

  return (
    <ListLayout title="Usuários">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="byName">
          <Input placeholder="Nome do usuário" className="lg:min-w-[300px]" />
        </Form.Item>
        <Form.Item name="byLogin">
          <Input placeholder="Login do usuário" className="lg:min-w-[300px]" />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="id"
          key="id"
          title="ID"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="login"
          key="login"
          title="Login"
          render={value => <TextField value={value} />}
        />
        <Table.Column<IAgent>
          dataIndex="roles"
          key="roles"
          title="Grupos"
          width={280}
          render={(_, record) => (
            <GroupsColumn
              permissions={record.permissions}
              rolePermissions={record.role_permissions}
              roles={record.roles}
            />
          )}
        />
        <Table.Column<IAgent>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={100}
          render={(_, record) => {
            return (
              <Space>
                <EditButton hideText size="small" recordItemId={record.id} />
                <DeleteButton hideText size="small" recordItemId={record.id} />
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
